import { useState } from "react";
import { Datasets } from "../../components/Dataset/Dataset";
import "../../styles/org-buttons.css";
import { useNavigate } from "react-router-dom";

import NavigationBar from "../../components/NavBar/NavBar";
import DatasetWorkspaceShell from "../../components/Dataset/DatasetWorkspaceShell";
import "../../styles/DatasetPage.css";
import ClassOperationModal from "./pages/ClassOpsPage";
import LabelsOperationModal from "./pages/LabelsOpsPage";
import FieldOperationModal from "./pages/FieldOpsPage";
import { buttonText } from "../../utils/buttonText";
import { pageText } from "../../utils/pageText";

function LabelsPage() {
  return (
    <div>
      <NavigationBar />
      <DatasetWorkspaceShell mainClassName="labels-page">
        <Datasets
          CustomizedContent={CustomizedContent}
          overviewTitle="Labels"
          overviewDescription="Manage label definitions and assign label workflows across selected datasets."
        />
      </DatasetWorkspaceShell>
    </div>
  );
}

const LinkStyle = {
  color: "blue",
  textDecoration: "underline",
  cursor: "pointer",
};

function DatasetInfoGrid({ item, sampleCount }) {
  return (
    <div className="dataset-info">
      <div className="dataset-info-grid">
        <div className="dataset-info-item">
          <span>{pageText("Type")}</span>
          <strong>{pageText(item.media_type || "unknown")}</strong>
        </div>
        <div className="dataset-info-item">
          <span>{pageText("Samples")}</span>
          <strong>{sampleCount.toLocaleString()}</strong>
        </div>
        <div className="dataset-info-item">
          <span>{pageText("Size")}</span>
          <strong>{item.size || "N/A"}</strong>
        </div>
      </div>
    </div>
  );
}

function CustomizedContent(props) {
  const { item, loadDatasetList, dbMapList } = props;

  const [fieldModalShow, setFieldModalShow] = useState(false);
  const [labelModalShow, setLabelModalShow] = useState(false);
  const [classModalShow, setClassModalShow] = useState(false);

  const sampleCount = item.samples?.length || 0;
  const navigate = useNavigate();
  const hasAnyLabel =
    item.sample_label_fields && item.sample_label_fields.length > 0;

  const noLabelDisplay = (
    <div className="info-section">
      <h6 className="card-text">{pageText("No Label in this dataset")}</h6>
      <p className="card-text">{pageText("To get labels, please:")}</p>
      <p className="card-text">
        {pageText("1. Go to")}{" "}
        <a
          onClick={() => navigate("/pre-label")}
          style={LinkStyle}
        >
          <strong>{pageText("Pre-Label")}</strong>
        </a>
        .
      </p>
      <p className="card-text">
        {pageText("2. Go to")}{" "}
        <a
          onClick={() => navigate("/cvat")}
          style={LinkStyle}
        >
          <strong>{pageText("Annotation")}</strong>
        </a>
        .
      </p>
    </div>
  );

  return (
    <div className="dataset-customized-content">
      <DatasetInfoGrid item={item} sampleCount={sampleCount} />
      {hasAnyLabel ? (
        <div className="data-processing-button-group">
          <button
            type="button"
            className="org-btn org-btn-secondary"
            onClick={() => setFieldModalShow(true)}
          >
            {buttonText("Field-Opt")}
          </button>
          <button
            type="button"
            className="org-btn org-btn-secondary"
            onClick={() => setLabelModalShow(true)}
          >
            {buttonText("Label-Opt")}
          </button>
          <button
            type="button"
            className="org-btn org-btn-secondary"
            onClick={() => setClassModalShow(true)}
          >
            {buttonText("Class-Opt")}
          </button>
        </div>
      ) : (
        noLabelDisplay
      )}
      <FieldOperationModal
        show={fieldModalShow}
        onHide={() => setFieldModalShow(false)}
        item={item}
        loadDatasetList={loadDatasetList}
      />
      <LabelsOperationModal
        show={labelModalShow}
        onHide={() => setLabelModalShow(false)}
        item={item}
        loadDatasetList={loadDatasetList}
      />
      <ClassOperationModal
        show={classModalShow}
        onHide={() => setClassModalShow(false)}
        item={item}
        loadDatasetList={loadDatasetList}
        dbMapList={dbMapList}
      />
    </div>
  );
}

export default LabelsPage;
